module.exports = "https://coursera_assets.s3.amazonaws.com/images/73195d308409b04df0eaff2ac64506df.svg";